import PostForm, {PostFormTypes as _PostFormTypes} from '~/components/Bulletin/PostForm/PostForm';

export const PostFormTypes = _PostFormTypes;
export default PostForm;